import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { useThemeValue } from '../../state/theme';
import { Link } from '../Link';
/**
 * Main menu secondary item, to be used inside the `MainMenuItem` component
 */
export const MainMenuSecondaryItem = (props) => {
    const { to, text } = props;
    const menuHoverClasses = useThemeValue('main-menu-item-hover', 'focus:bg-gray-100 hover:bg-gray-100');
    return (_jsx(Link, Object.assign({ to: to, className: clsx('pl-12 py-1 duration-100 transition-colors last:mb-4', menuHoverClasses) }, { children: text }), void 0));
};
//# sourceMappingURL=MainMenuSecondaryItem.js.map